module.exports = __webpack_public_path__ + "static/media/moderate-image.7f662d8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moderate-image.png
// module id = 270
// module chunks = 2